<template>
  <div class="modal" :class="{ active: isVisible }">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">用户预约详情</h3>
        <button class="close-modal" @click="closeModal">&times;</button>
      </div>
      
      <div class="detail-section">
        <h4>基本信息</h4>
        <div class="user-detail-row">
          <div class="detail-label">姓名：</div>
          <div class="detail-value">{{ userDetails.name }}</div>
        </div>
        <div class="user-detail-row">
          <div class="detail-label">学校/机构：</div>
          <div class="detail-value">{{ userDetails.organization }}</div>
        </div>
        <div class="user-detail-row">
          <div class="detail-label">职位：</div>
          <div class="detail-value">{{ userDetails.position }}</div>
        </div>
        <div class="user-detail-row">
          <div class="detail-label">联系方式：</div>
          <div class="detail-value">
            {{ userDetails.phone }}<br>
            {{ userDetails.email }}
          </div>
        </div>
      </div>
      
      <div class="detail-section">
        <h4>预约信息</h4>
        <div class="user-detail-row">
          <div class="detail-label">申请时间：</div>
          <div class="detail-value">{{ userDetails.submitTime }}</div>
        </div>
        <div class="user-detail-row">
          <div class="detail-label">兴趣模块：</div>
          <div class="detail-value">{{ userDetails.interest }}</div>
        </div>
        <div class="user-detail-row">
          <div class="detail-label">当前状态：</div>
          <div class="detail-value">
            <span :class="['status-badge', userDetails.status]">
              {{ getStatusText(userDetails.status) }}
            </span>
          </div>
        </div>
      </div>
      
      <div class="detail-section">
        <h4>原始提交数据</h4>
        <pre style="white-space: pre-wrap; background: #f8fafc; padding: 15px; border-radius: 6px; border: 1px solid #e0e6ef;">
{{ JSON.stringify(userDetails, null, 2) }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserDetailModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    userDetails: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    getStatusText(status) {
      const statusMap = {
        'create': '待处理',
        'contacted': '已联系',
        'rejected': '已拒绝',
      };
      return statusMap[status] || status;
    }
  }
}
</script>